module.exports = __webpack_public_path__ + "img/18741ba498694afaa721aeddf5ee7d40.b2ae9efc.jpg";